import { Label, Error, Icon, ClassHelper } from 'components/lib';
import Style from './input.tailwind.js';
import { useTranslate } from 'app/translations.js';

export function TextInput(props){
  const { _t } = useTranslate();
  const error = props.errorMessage || _t('value.empty');

  function validate(e){

    let value = e ? e.target.value : '';
    let valid = undefined;

    // input is required and value is blank
    if (props.required && value === '')
      valid = false;

    // input isn't required and value is blank
    if (!props.required && value === '')
      valid = true;

    if (props.required && value !== '')
      valid = true;

    // update the parent form
    props.onChange?.(props.name, value, valid);

  }

  // style
  const textStyle = ClassHelper(Style, {

    // the reference has a separate Textarea with its own min-height
    textbox: props.type !== 'textarea',
    textarea: props.type === 'textarea',
    className: props.className, 
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning

  });

  return(
    <div className={ Style.input }>

      { props.label && 
        <Label
          text={ props.label }
          required={ props.required }
          for={ props.name }
        /> }

      {/* The check is positioned against this wrapper, not the whole block, so
          it stays centred on the control with or without a label. */}
      <div className={ Style.field }>

        { props.type === 'textarea' ?

          <textarea
            id={ props.id }
            rows={ props.rows }
            name={ props.name }
            value={ props.value }
            className={ textStyle }
            placeholder={ props.placeholder }
            onChange={ e => props.onChange?.(props.name, e.target.value, undefined) }
            onBlur={ e => validate(e) }
          >
          </textarea>

          :

          <input
            type='text'
            disabled={ props.disabled }
            id={ props.id }
            name={ props.name }
            value={ props.value || '' }
            className={ textStyle }
            placeholder={ props.placeholder }
            onChange={ e => props.onChange?.(props.name, e.target.value, undefined) }
            onBlur={ e => validate(e) }
          />
        }

        { props.valid === true &&
          <Icon
            image='check'
            color='currentColor'
            className={ props.type === 'textarea' ? Style.successIconTextarea : Style.successIcon }
            size={ 16 }
          />}

      </div>

      { props.valid === false &&
        <Error message={ error }/> }

    </div>
  );
}
